import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { Reservation } from '../classes/reservation';

@Injectable({
  providedIn: 'root'
})
export class ReservationRuleService {

  constructor(private httpClient: HttpClient) { }

//   public CreateReservation(reservation: Reservation): Observable<any>
//   {
//     return this.httpClient.post(`${environment.apiUrl}/api/reservations`, reservation) as Observable<any>;
//   }

  public GetDisabledSlotsForDate(date: string): Observable<any>
  {
    return this.httpClient.get(`${environment.apiUrl}/api/reservationRules/GetReservationRule/${date}`) as Observable<any>;
  }

  public updateReservationRules(dates: any[], date: string): Observable<any>
  {
    return this.httpClient.post(`${environment.apiUrl}/api/reservationRules/UpdateReservationRules/${date}`, dates) as Observable<any>;
  }
}
